import { ToastrModule, ToastrService } from 'ngx-toastr';
import { CommunicationService } from '../../../services/communication/communication.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate//core';
const utf8 = require('utf8');



@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss']
})
export class EmailComponent implements OnInit {

  public emailForm!: FormGroup;
  dataRegister: any = {};
  userName: String = "";
  translateService: TranslateService;

  //configuration for custom textarea
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '200px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    sanitize: false,
    toolbarPosition: 'top',

  };
  constructor(private _fb: FormBuilder,
    private _communicationService: CommunicationService,
    private _toastr: ToastrService,
    private _router: Router,
    private _translateService: TranslateService) { }

  ngOnInit() {
    this.translateService = this._translateService;
    let utilisateur = JSON.parse(localStorage.getItem('gapUtilisateur'));
		if (utilisateur) {
      this.userName = utilisateur.Login;
      if (utilisateur.Nom != null && utilisateur.Nom != "") {
			  this.userName += " - " + utilisateur.Nom + " " + utilisateur.Prenom;
      }
		}
    this.emailForm = this._fb.group({
      de: [this.userName],
      sujet: [null, Validators.required],
      message: [null, Validators.required]
    });
  }

  emailSubmit() {
    if (!this.emailForm.valid) throw new Error(this.translateService.instant("email.formulaire-incorrect"));

    try {
      this._communicationService.envoieEmailContactDossier({
        Objet: "Base64:" + btoa(utf8.encode(this.emailForm.value.sujet)),
        Message: "Base64:" + btoa(utf8.encode(this.emailForm.value.message + "<br><br>" + this.userName))
      })
        .subscribe({
          next: data => {
            if (data) {
              this._toastr.success(this.translateService.instant("email.mail-envoye"));
              this._router.navigateByUrl('/');
            }
          }
        })

    } catch (error) {
      console.error(error);
      this._toastr.error(this.translateService.instant("email.erreur-envoi"));
    }


  }



}
